export default {
  close: 'ปิด',
  dataIterator: {
    pageText: '{0}-{1} จาก {2}',
    noResultsText: 'ไม่พบผลการค้นหา',
    loadingText: 'กำลังโหลด...',
  },
  dataTable: {
    itemsPerPageText: 'แถวต่อหน้า:',
    ariaLabel: {
      sortDescending: ': เรียงลำดับจากมากไปน้อย คลิกเพื่อยกเลิกการเรียงลำดับ',
      sortAscending: ': เรียงลำดับจากน้อยไปมาก คลิกเพื่อเรียงลำดับจากมากไปน้อย',
      sortNone: ': ไม่ได้เรียงลำดับ คลิกเพื่อเรียงลำดับจากน้อยไปมาก',
    },
    sortBy: 'เรียงลำดับโดย',
  },
  dataFooter: {
    itemsPerPageText: 'รายการต่อหน้า:',
    itemsPerPageAll: 'ทั้งหมด',
    nextPage: 'หน้าถัดไป',
    prevPage: 'หน้าก่อนหน้า',
    firstPage: 'หน้าแรก',
    lastPage: 'หน้าสุดท้าย',
  },
  datePicker: {
    itemsSelected: 'เลือก {0} วัน',
  },
  noDataText: 'ไม่มีข้อมูล',
  carousel: {
    prev: 'ภาพก่อนหน้า',
    next: 'ภาพถัดไป',
  },
  calendar: {
    moreEvents: 'อีก {0} รายการ',
  },
  fileInput: {
    counter: 'ไฟล์ {0} ไฟล์',
    counterSize: 'ไฟล์ {0} ไฟล์ (ทั้งหมด {1})',
  },
  observation: {
    accumulatedTemperature: 'อุณหภูมิสะสมที่มีผล',
    accumulatedTemperatureList: 'รายการอุณหภูมิสะสมที่มีผล',
    startDateCalculation: 'วันที่เริ่มต้นการคำนวณ',
    endDateCalculation: 'วันที่สิ้นสุดการคำนวณ',
    lowerLimitTemperature: 'อุณหภูมิต่ำสุด',
    registerAndEditAccumulatedTemperaturePoints: 'ลงทะเบียน/แก้ไขจุดคำนวณอุณหภูมิสะสมที่มีผล',
    period: 'ช่วงเวลา',
    accumulatedLowerLimitTemperature: 'อุณหภูมิต่ำสุดสะสม',
    deleteAccumulatedTemperatureLocation: 'คุณแน่ใจหรือไม่ว่าต้องการลบจุดสังเกตอุณหภูมิสะสมของ "{fieldName}"',
    soilMoisture: 'ความชื้นในดิน',
    soilTemperature: 'อุณหภูมิดิน',
    precipitation: 'ปริมาณน้ำฝน',
    soilMoistureList: 'รายการความชื้นในดิน',
    maxRegisterCount: '(สูงสุด {count} รายการ)',
    soilConditionVeryWet: 'เปียกมาก',
    soilConditionWet: 'เปียก',
    soilConditionDry: 'แห้ง',
    soilConditionVeryDry: 'แห้งมาก',
    drainage: 'ลักษณะของดิน',
    registerAndEditSoilMoisturePoints: 'ลงทะเบียน/แก้ไขจุดคำนวณความชื้นในดิน',
    soilMoistureConditionGood: 'ดินร่วนปนทราย',
    soilMoistureConditionSlightlyBad: 'ดินร่วน',
    soilMoistureConditionBad: 'ดินเหนียว',
    soilMoistureConditionSandyLoam: 'ดินร่วนปนทราย',
    soilMoistureConditionClayLoam: 'ดินร่วน',
    soilMoistureConditionClay: 'ดินเหนียว',
    deleteSoilMoistureLocation: 'คุณแน่ใจหรือไม่ว่าต้องการลบจุดสังเกตความชื้นในดินของ "{fieldName}"',
    deletedField: '< ลบฟิลด์แล้ว >',
    validateForStartDateBeforeYesterday: 'วันที่เริ่มต้นต้องเป็นวันก่อนหน้าอย่างน้อย 1 วัน',
    validateForStartEndDateOrder: 'วันที่สิ้นสุดต้องอยู่หลังวันที่เริ่มต้น',
    validateForStartEndDuration: 'วันที่เริ่มต้นและวันที่สิ้นสุดต้องอยู่ในช่วง {day} วัน',
    validateForStartNowDuration: 'วันที่เริ่มต้นต้องอยู่ในช่วง {day} วันนับจากวันนี้',
  },
  caster: {
    rtkInfo: 'ข้อมูลการแก้ไข RTK',
    rtkLog: 'บันทึกการสื่อสาร',
    myBaseStationStatus: 'สถานะสถานีฐานของฉัน',
    howToSetupRtkBase: 'เมื่อส่งข้อมูลการแก้ไขจากผลิตภัณฑ์อื่นๆ ไปยัง "สถานีฐานของฉัน"',
    howToSetupRtkRover: 'เมื่อรับข้อมูลการแก้ไขจาก "สถานีฐานของฉัน" ในผลิตภัณฑ์อื่นๆ',
    host: 'โฮสต์',
    port: 'พอร์ต',
    mountpoint: 'จุดเชื่อมต่อ',
    derivedPassthroughLabel: ' (ไม่แปลง)',
    derivedPassthroughCaption: 'ส่งข้อมูลแก้ไขจากสถานีฐานตามต้นฉบับ โดยปกติให้ใช้ตัวเลือกนี้',
    derivedMsm4Label: ' (ความเข้ากันได้)',
    derivedMsm4Caption: 'แปลงเป็นรูปแบบ MSM4: สำหรับเครื่องรับที่ไม่เสถียรกับรูปแบบล่าสุด (เช่น MSM7)',
    derivedLegacyLabel: ' (สำหรับเครื่องรับรุ่นเก่า)',
    derivedLegacyCaption: 'แปลงเป็นรูปแบบเก่า 1004/1012: รองรับเฉพาะ GPS+GLONASS',
    derivedNote:
      'หากไม่ได้รับข้อมูลแก้ไขหรือไม่ FIX โปรดลอง _MSM4 / _LEGACY หากเชื่อมต่อสถานีฐานที่ไม่ใช่ของ AgriBus เอาต์พุตนี้อาจไม่พร้อมใช้งาน',
    messageTypesTitle: 'ประเภทข้อความที่ส่งออก (ข้อมูลทางเทคนิค)',
    messageTypesIntro:
      'หากผู้ผลิตเครื่องรับสอบถามว่าสถานีฐานส่งข้อความ RTCM ประเภทใด โปรดแจ้งรายการด้านล่างตาม mount point ที่ใช้เชื่อมต่อ',
    messageTypesPassthrough:
      'ส่งข้อมูลจากสถานีฐานโดยไม่เปลี่ยนแปลง สำหรับสถานีฐาน AgriBus-GMiniR ของเรา: RTCM 3.3 / MSM4+MSM7 (1074/1077 GPS, 1084/1087 GLONASS, 1094/1097 Galileo, 1124/1127 BeiDou) ทุกวินาที พร้อม 1005 (ตำแหน่งสถานี), 1008 (ข้อมูลเสาอากาศ) และ 1230 (ค่าชดเชยโค้ด-เฟส GLONASS) สำหรับสถานีฐานของผู้ผลิตรายอื่นขึ้นอยู่กับการตั้งค่าอุปกรณ์นั้น',
    messageTypesMsm4:
      'แปลงเป็น RTCM 3.3 / MSM4: 1074 (GPS), 1084 (GLONASS), 1094 (Galileo), 1114 (QZSS), 1124 (BeiDou) ทุกวินาที (เฉพาะระบบดาวเทียมที่สถานีฐานรับได้) พร้อม 1006, 1033 และ 1230 ทุก 5 วินาที',
    messageTypesLegacy:
      'รูปแบบเก่า (แบบ RTCM 3.1): 1004 (GPS L1/L2) และ 1012 (GLONASS L1/L2) ทุกวินาที พร้อม 1006 และ 1008 ทุก 5 วินาที (ไม่ส่ง 1033/1230) เวลาของข้อมูลสังเกตจะถูกปรับให้ตรงวินาทีเต็ม จึงใช้ได้กับเครื่องรับที่ต้องการเวลาตรงวินาทีเต็มด้วย',
    baseStation: 'สำหรับสถานีฐานของฉัน',
    rover: 'สถานีเคลื่อนที่',
    userId: 'รหัสผู้ใช้',
    ntripUserId: 'รหัสผู้ใช้ Ntrip',
    ntripPassword: 'รหัสผ่าน Ntrip',
    showCaption: 'แสดง',
    statusTab: 'สถานะ',
    qualityTab: 'คุณภาพ',
    mapTab: 'แผนที่',
    logTab: 'บันทึกการเชื่อมต่อ',
    settingsTab: 'การตั้งค่า',
    baseShort: 'สถานีฐาน',
    casterServer: 'เซิร์ฟเวอร์ caster',
    roverShort: 'โรเวอร์',
    receiving: 'กำลังรับ',
    stale: 'การรับหยุดชะงัก',
    noConnection: 'ไม่ได้เชื่อมต่อ',
    lastReceivedAt: 'รับล่าสุด',
    disconnectedAt: 'ตัดการเชื่อมต่อ',
    summaryTitle: 'การรับของสถานีฐาน',
    lastSnapshotNote: 'ค่าสุดท้ายก่อนตัดการเชื่อมต่อ',
    noStatsData: 'ไม่มีข้อมูลจากสถานีฐาน',
    bytesRate: 'อัตราข้อมูล',
    messagesPerSecond: 'ข้อความ',
    epochInterval: 'ช่วงเวลา epoch',
    uptime: 'เวลาเชื่อมต่อ',
    decodeErrors: 'ข้อผิดพลาดการถอดรหัส',
    basePosition: 'ตำแหน่งสถานีฐาน',
    antenna: 'เสาอากาศ',
    satellites: 'ดาวเทียม',
    signals: 'สัญญาณ',
    meanCnr: 'C/N0 เฉลี่ย',
    msgType: 'ข้อความ',
    msgCount: 'จำนวน',
    msgInterval: 'ช่วงเวลา',
    msgLastSeen: 'รับล่าสุด',
    cnrChart: 'C/N0 เฉลี่ย (dB-Hz)',
    satsChart: 'ดาวเทียม',
    rateChart: 'อัตราข้อมูล (ไบต์/วินาที)',
    epochChart: 'ช่วงเวลา epoch (มิลลิวินาที)',
    noHistoryData: 'ยังไม่มีข้อมูลประวัติ',
    noTrackData: 'ไม่มีบันทึก GGA ของโรเวอร์',
    baseline: 'เส้นฐาน',
    fixQuality: 'คุณภาพ fix',
    ggaPoints: 'จุดที่บันทึก',
    logBaseTitle: 'การเชื่อมต่อสถานีฐาน',
    logRoverTitle: 'การเชื่อมต่อโรเวอร์',
    startAt: 'เริ่ม',
    endAt: 'สิ้นสุด',
    inSession: 'เชื่อมต่ออยู่',
    userAgentLabel: 'ไคลเอนต์',
    logNote: 'แสดงบันทึกของ 24 ชั่วโมงล่าสุด',
  },
  print: {
    field: {
      fillSetting: 'เติมสีฟิลด์',
      backgroundWhiteColorSetting: 'พื้นหลังสีขาว',
      backgroundNoColorSetting: 'ไม่มีพื้นหลัง',
      printText: 'พิมพ์',
      showFieldName: 'แสดงชื่อฟิลด์',
    },
  },
  sortOptions: {
    title: 'ลำดับการจัดเรียง',
    field: {
      name: 'ชื่อฟิลด์',
      createdAt: 'วันที่ลงทะเบียน',
      lastModifiedDateTime: 'วันที่แก้ไขล่าสุด',
    },
  },
  fieldElevation: {
    title: 'ระดับความสูง',
    cantBuildBecauseNoTask: 'ไม่สามารถสร้างแผนที่ระดับความสูงได้ เนื่องจากไม่มีประวัติการทำงาน',
    nowBuilding: 'กำลังสร้าง... (อาจใช้เวลานานขึ้นอยู่กับขนาดของฟิลด์)',
    updatedAt: 'วันที่สร้าง',
    meshSize: 'ขนาดตาข่าย',
    taskFetchLimit: 'ปริมาณข้อมูลอ้างอิง',
    taskDateRange: 'ช่วงการทำงาน',
    taskPointCount: 'จำนวนจุดทำงาน',
    editButton: 'แก้ไข',
    createButton: 'สร้าง',
    needStandardPlan: 'ต้องใช้ Standard Plan ในการสร้างแผนที่ระดับความสูง',
    taskFetchLimitHint: 'เพิ่มขึ้นหากไม่มีระดับความสูง ปรับลดลงหากมีสัญญาณรบกวนมาก',
    creationFailedMessage: 'ไม่สามารถสร้างแผนที่ระดับความสูงได้',
    gnssStatus: 'สถานะ GNSS',
    elevationRange: 'ช่วงระดับความสูง',
    optionSetting: 'การตั้งค่าตัวเลือก (เบต้า)',
    minValue: 'ค่าต่ำสุด',
    maxValue: 'ค่าสูงสุด',
    minIgnoreCaption: 'ระดับความสูงที่ต่ำกว่าค่านี้จะถูกละเว้น',
    maxIgnoreCaption: 'ระดับความสูงที่สูงกว่าค่านี้จะถูกละเว้น',
    minValueNeedError: 'กรุณาตั้งค่าต่ำสุด',
    maxValueNeedError: 'กรุณาตั้งค่าสูงสุด',
    minValueRangeError: 'ค่าต่ำสุดต้องน้อยกว่าค่าสูงสุด',
    maxValueRangeError: 'ค่าสูงสุดต้องมากกว่าค่าต่ำสุด',
    invalidOptionSettingError: 'มีการระบุการตั้งค่าตัวเลือกที่ไม่ถูกต้อง',
    dateRangeInput: 'ระบุช่วงวันที่',
    oldestTaskDateInput: 'วันที่เริ่มต้น',
    newestTaskDateInput: 'วันที่สิ้นสุด',
  },

  navi: {
    GeneralMainSettingMenuGnssSource: 'แหล่งที่มาของ GNSS',
    GeneralMainSettingGnssSourceInternal: 'GNSS ในตัวเครื่อง',
    GeneralMainSettingGnssSourceGPlus: 'AgriBus-G+',
    GeneralMainSettingGnssSourceG2: 'AgriBus-G2',
    GeneralMainSettingGnssSourceGMini: 'AgriBus-GMini',
    GeneralMainSettingGnssSourceGMiniR: 'AgriBus-GMiniR',
    GeneralMainSettingGnssSourceUsb: 'GNSS เชื่อมต่อ USB',
    GeneralMainSettingGnssSourceBluetooth: 'GNSS เชื่อมต่อ Bluetooth',
    GeneralMainSettingGnssSourceTcpPort: 'การสื่อสารพอร์ตภายใน',
    GeneralMainSettingGnssSourceNtripClient: 'ไคลเอ็นต์ Ntrip (Trimble, Topcon)',
    GeneralMainSettingGnssSourceVirtual: 'เสมือน',
  },

  ValidationTextRequired: 'กรุณากรอกข้อมูล',
  ResetPasswordTitle: 'รีเซ็ตรหัสผ่าน',
  ResetPasswordButton: 'รีเซ็ตรหัสผ่าน',
  ResetPasswordDescription:
    'ลิงก์สำหรับรีเซ็ตรหัสผ่านจะถูกส่งไปยังที่อยู่อีเมลที่คุณลงทะเบียนไว้ กรุณารีเซ็ตรหัสผ่านของคุณโดยทำตามคำแนะนำในอีเมล',
  ValidationBadEmail: 'กรุณากรอกที่อยู่อีเมลที่ถูกต้อง',
  ChangePasswordButton: 'เปลี่ยนรหัสผ่าน',
  CreatePasswordButton: 'สร้างรหัสผ่าน',
  UnitTitle: 'หน่วยการแสดงผล',
  UnitMetric: 'ระบบเมตริก',
  UnitImperial: 'ระบบอังกฤษ',
  UnitJpUnitsOfArea: 'หน่วยพื้นที่ของญี่ปุ่น',
  UnitThUnitsOfArea: 'หน่วยพื้นที่ของไทย',
  NickNameHint: 'ชื่อที่แสดง',
  SendMeNews: 'ส่งข้อมูลล่าสุดไปยังที่อยู่อีเมล',
  FreePlanDisplayName: 'Free Plan',
  StandardPlanDisplayName: 'Standard Plan',
  ChangePasswordTitle: 'เปลี่ยนรหัสผ่าน',
  CreatePasswordTitle: 'สร้างรหัสผ่าน',
  CurrentPasswordHint: 'รหัสผ่านปัจจุบัน',
  NewPasswordHint: 'รหัสผ่านใหม่',
  SignInButton: 'เข้าสู่ระบบ',
  ToResetPasswordButton: 'ลืมรหัสผ่าน?',
  DocFormFieldDetailFieldNameHint: 'ชื่อฟิลด์',
  DocFormTaskRecordDetailFieldNameHint: 'ชื่อบันทึกการทำงาน',
  DocFormTaskRecordDetailDescriptionHint: 'หมายเหตุ',
  DocFormTabNameTaskRecordList: 'ประวัติการทำงาน',
  DocFormTabNameRefLineList: 'เส้นฐานสำหรับนำทาง',
  DocFormTabNameGridPointsList: 'ข้อมูลตาข่าย',
  DocFormTabNameFieldList: 'แปลง',
  DocFormFieldRegisteredDateFormatBase: 'วันที่ลงทะเบียน: {createDate}',
  DocFormMenuItemSignOut: 'ออกจากระบบ',
  DocFormFieldDetailDescriptionHint: 'หมายเหตุ',
  StandardPlanIsNeededDialogMessage:
    'ฟังก์ชันนี้สามารถใช้ได้โดยการสมัครสมาชิก Standard Plan (มีช่วงทดลองใช้ฟรี 30 วัน)',

  SelectPlanDialogTitle: 'เลือกแผน',
  SelectPlanDialogRecommend: 'แนะนำ',
  SelectPlanDialogYearPlan: 'แผนรายปี',
  SelectPlanDialogYearPlanGreatValue: '(คุ้มค่ากว่า 2 เดือน)',
  SelectPlanDialogYearMonth: 'แผนรายเดือน',
  StandardPlanPriceForMonthBatch: 'ค่าสมัครสมาชิกรายปี',
  StandardPlanPricePerMonth: '/เดือน',
  StandardPlanPricePerYear: '/ปี',
  StandardPlanPriceForYearNotice: '*ชำระเงินเป็นเวลา 12 เดือน',
  SelectPlanSubscribeYear: 'เริ่มทดลองใช้ 30 วัน',
  SelectPlanSubscribeMonth: 'เริ่มทดลองใช้ 30 วัน',
  selectPlanDataViewNote:
    '* หากคุณไม่ต่ออายุการสมัครภายในประมาณ 1 เดือนหลังการยกเลิก ข้อมูลที่บันทึกก่อนการยกเลิกจะไม่แสดงอีกต่อไป (มีผลตั้งแต่ 1 ตุลาคม 2026) โปรดส่งออกข้อมูลที่จำเป็นในระหว่างที่การสมัครยังมีผล',

  DefaultRefLineTypeStraight: 'เส้นตรง',
  DefaultRefLineTypeCurved: 'เส้นโค้ง',

  customSelectAll: 'เลือกทั้งหมด',
  customUnSelectAll: 'ยกเลิกการเลือกทั้งหมด',

  customRegistration: 'ลงทะเบียน',
  customUpdate: 'อัปเดต',
  customSearch: 'ค้นหา',
  customDelete: 'ลบ',
  customAllow: 'อนุญาต',
  customDeny: 'ปฏิเสธ',
  customDefault: 'ค่าเริ่มต้น',
  customSelected: 'เลือกแล้ว',
  customSelectThis: 'เลือกสิ่งนี้',

  customArea: 'พื้นที่',

  customNotAvailable: 'ไม่สามารถใช้งานได้',
  customEdit: 'แก้ไข',
  customCancel: 'ยกเลิก',
  customNone: 'ไม่มี',
  customClose: 'ปิด',
  customFieldDrawHint:
    'คลิกแผนที่เพื่อเพิ่มจุดยอดของแปลง แล้วกดปุ่มเครื่องหมายถูกเพื่อยืนยัน (ปุ่มย้อนกลับ / Backspace ลบจุดล่าสุด)',
  customBack: 'ย้อนกลับ',
  customRefresh: 'รีเฟรช',

  customUpload: 'อัปโหลด',

  customPriceIncludingTax: 'ราคา (รวมภาษี)',
  customPay: 'ชำระเงิน',
  customCancelContract: 'ยกเลิกสัญญา',

  customConfirmReally: 'คุณแน่ใจหรือไม่',

  customRememberMe: 'จดจำฉัน',
  customLogin: 'เข้าสู่ระบบ',
  customNowLoggingIn: 'กำลังเข้าสู่ระบบ...',
  customEmail: 'ที่อยู่อีเมล',
  customPassword: 'รหัสผ่าน',
  customUser: 'ผู้ใช้',
  customUserSettings: 'การตั้งค่าผู้ใช้',
  customSentEMailMessage: 'ส่งอีเมลแล้ว',
  customNewPasswordReInput: 'ป้อนรหัสผ่านใหม่ของคุณอีกครั้ง',
  customValidationPasswordMinLength: 'รหัสผ่านต้องมีความยาวอย่างน้อย {length} ตัวอักษร',
  customValidationPasswordMaxLength: 'ยาวเกินไป',
  customValidationPasswordNotMatch: 'รหัสผ่านไม่ตรงกัน',
  customChangePasswordSuccess: 'เปลี่ยนรหัสผ่านแล้ว',
  customGoToLoginPageTitle: 'กลับไปหน้าเข้าสู่ระบบ',
  customYouDontHaveAccount: 'หากคุณไม่มีบัญชี',

  customRegisterAgriBusWeb: 'ลงทะเบียน AgriBus-Web',

  customChange: 'เปลี่ยนแปลง',
  customLanguage: 'ภาษา',
  customSaveAction: 'บันทึก',
  customSaveSuccess: 'บันทึกแล้ว',

  customAddAction: 'เพิ่ม',

  customPlan: 'แผน',
  customPlanExpirationDate: 'วันหมดอายุ: {expirationDate}',
  customPlanDescription: 'หากต้องการเปลี่ยนแผน โปรดดำเนินการจากแอปพลิเคชัน Android (AgriBus-NAVI)',
  customPlanOnly: 'สำหรับ Standard Plan เท่านั้น',

  customDetail: 'รายละเอียด',

  customDatePickerNullAlert: 'กรุณาเลือกวันที่ก่อน',
  customTaskNotFound: 'ไม่พบบันทึกการทำงาน',
  customTaskNotFoundAtDate: 'ไม่พบบันทึกการทำงาน วันที่ทำงาน: {date}',
  customErrorInitTasksFreePlan: 'Free Plan ถูกจำกัดประวัติสูงสุด 2 วัน',
  customErrorInitTasksNoTasks: 'หากไม่มีสิ่งใดปรากฏขึ้น โปรด "ซิงโครไนซ์ข้อมูล" ใน AgriBus-NAVI!',
  customErrorInitFieldsNoFields: 'ไม่มีการลงทะเบียนฟิลด์ หรือไม่ได้ "ซิงโครไนซ์ข้อมูล" ใน AgriBus-NAVI',

  customColored: 'รหัสสี',
  customHeight: 'ความสูง',
  customHeightMap: 'แผนที่ความสูง',
  customSpeed: 'ความเร็ว',

  customDate: 'วันที่และเวลา',
  customWorkWidth: 'ความกว้างในการทำงาน',
  customWorkedArea: 'พื้นที่ทำงาน',
  customOverlappedArea: 'พื้นที่ทับซ้อน',
  customTaskRecordEfficiency: 'ประสิทธิภาพการทำงาน',
  customDistance: 'ระยะทาง',
  customWorkedTime: 'เวลาทำงาน',
  customAverageSpeed: 'ความเร็วเฉลี่ย',
  customWorker: 'ผู้ปฏิบัติงาน',

  customDocFormTaskRecordDistanceOfFormatBase: '{distance} (เฉลี่ย {speed})',
  customDocFormTaskRecordWorkedAreaPercentageFormatBase: '{percentage}% ของ {fieldArea}',
  customDocFormTaskRecordWorkedAreaInfoFormatBase: '{areaPercentageText}, {efficiencyText}/ชม.',

  customPageSuffix: 'หน้า',
  customDisplayCount: 'จำนวนที่แสดง',
  customTotalCount: 'ทั้งหมด {count} รายการ',

  customListingModeSelf: 'เฉพาะฉัน',
  customListingModeAll: 'รวมการติดตาม',

  customIconSettings: 'การตั้งค่าไอคอน',

  customAccountHeader: 'บัญชี',
  customConnectionHeader: 'การเชื่อมต่อ',
  customConnectionTitle: 'การเชื่อมต่อ',
  customFollowRequest: 'คำขอติดตาม',

  customFollow: 'ติดตาม',
  customUnfollow: 'เลิกติดตาม',
  customFollowing: 'กำลังติดตาม',
  customFollower: 'ผู้ติดตาม',

  customHaveNoFollowings: 'ไม่ได้ติดตามใคร',
  customHaveNoFollowers: 'ไม่มีผู้ติดตาม',

  customInbox: 'กล่องข้อความขาเข้า',
  customOutbox: 'กล่องข้อความขาออก',

  customInboxEmpty: 'ไม่มีคำขอติดตามที่ได้รับ',
  customOutboxEmpty: 'ไม่มีคำขอติดตามที่ส่ง',
  customSendFollowRequest: 'ส่งคำขอติดตาม',
  customSendFollowRequestMessage: 'ส่งคำขอติดตามแล้ว',

  customFollowRequestSelfRequestError: 'ไม่สามารถส่งคำขอติดตามถึงตัวเองได้',
  customAllowFollowRequest: 'อนุมัติคำขอติดตามจาก {fromNickname} แล้ว',
  customUnfollowMessage: 'เลิกติดตามแล้ว',

  customUpdatedIconMessage: 'เปลี่ยนไอคอนแล้ว',
  customIconNowSelected: 'กำลังเลือกอยู่ในขณะนี้',
  customIcon: 'ค่าเริ่มต้น',
  customIconSettingsDescription: 'ขอแนะนำให้คุณตั้งค่าไอคอนของคุณเอง',
  customIconChangeToIcon: 'เปลี่ยนเป็นค่าเริ่มต้น',
  customGravatarIcon: 'Gravatar',
  customIconSettingsGravatarDescription: 'สะดวกในการเลือกหากคุณได้ตั้งค่าไอคอนไว้ที่ Gravatar',
  customIconChangeToGravatar: 'เปลี่ยนเป็น Gravatar',
  customCustomIcon: 'กำหนดเอง',
  customIconSettingsCustomDescription: 'คุณสามารถตั้งค่ารูปภาพที่คุณชื่นชอบได้ โปรดเตรียมไฟล์ JPEG หรือ PNG',
  customIconChangeToCustom: 'เปลี่ยนเป็นแบบกำหนดเอง',
  customIconReUpload: 'อัปโหลดอีกครั้ง',

  customTemperature: 'อุณหภูมิ',
  customHumidity: 'ความชื้น',
  customWind: 'ความเร็วลม',
  customPressure: 'ความกดอากาศ',
  customSunrise: 'พระอาทิตย์ขึ้น',
  customSunset: 'พระอาทิตย์ตก',

  customShowAllCropsDescription: 'แสดงทั้งหมด',
  customShowCurrentCropsDescription: 'แสดงเฉพาะปัจจุบัน',

  customProduct: 'การเพาะปลูก',
  customProductsNotFound: 'ไม่พบข้อมูลการเพาะปลูก',

  customColor: 'สี',
  customYear: 'ปี',
  customCrop: 'พืชผล',
  customCropVariety: 'พันธุ์',
  customDeleteCropConfirmationMessage:
    'คุณแน่ใจหรือไม่ว่าต้องการลบ {cropYear} {cropName} {cropVariety} (ข้อมูลที่เกี่ยวข้องจะถูกลบด้วย)',

  customOperationType: 'การดำเนินการ',

  customFilter: 'ตัวกรอง',
  customOutOfField: 'นอกแปลง',

  customBillingPlan: 'แผนการเรียกเก็บเงิน',
  customBillingAndPayment: 'การเรียกเก็บเงินและการชำระเงิน',
  customBillingMethod: 'วิธีการชำระเงิน',
  customBillingExistingCard: 'บัตรที่ลงทะเบียนแล้ว',
  customBillingAddNewCard: 'เพิ่มบัตรใหม่',
  customBillingMethodConfirm: 'กรุณายืนยันวิธีการชำระเงิน',
  customBillingHistory: 'ประวัติการชำระเงิน',

  customCreditCard: 'บัตรเครดิต',
  customCreditCardLast4: '4 หลักสุดท้าย',
  customCreditCardNameOnCard: 'ชื่อบนบัตร',
  customCreditCardInfo: 'ข้อมูลบัตรเครดิต',
  customCreditCardAddCard: 'เพิ่มบัตร',
  customCreditCardAddCardCaution1:
    'จะไม่มีการเรียกเก็บเงิน ณ เวลาที่ลงทะเบียน แต่จะตั้งค่าเป็นบัตรสำหรับการชำระเงินในอนาคต',
  customCreditCardAddCardCaution2:
    'หากคุณต้องการชำระเงินด้วยใบแจ้งหนี้ กรุณาติดต่อ contact@agri-info-design.com ก่อนลงทะเบียนบัตร',
  customCreditCardNoCard: 'ไม่มีบัตรเครดิตที่ลงทะเบียน',
  customCreditCardDeleteFailure: 'ไม่สามารถลบบัตรได้',

  customMyProducts: 'ผลิตภัณฑ์ของฉัน',
  customMyProductsList: 'รายการผลิตภัณฑ์',

  customMyProductProduct: 'สินค้า',
  customMyProductProductNumber: 'หมายเลขผลิตภัณฑ์',
  customMyProductDataPlan: 'แผนข้อมูล',
  customMyProductDataPlanSubscribe: 'สมัครแผนข้อมูล',
  customMyProductDataPlanSubscribeSuccessMessage: 'การสื่อสาร 3G ของ {productNumber} จะเปิดใช้งานในไม่ช้า',
  customMyProductDataPlanExpiredMessage: 'หมดอายุ {expiredDate}',
  customMyProductDataPlanCancelConfirmationMessage:
    'การยกเลิกสัญญาจะปิดใช้งานการสื่อสาร 3G นอกจากนี้ จะไม่มีการคืนเงินส่วนต่างแม้ว่าจะยังคงเหลือระยะเวลาสัญญาอยู่ อย่างไรก็ตาม คุณสามารถทำสัญญาใหม่ได้อีกครั้ง คุณแน่ใจหรือไม่ว่าต้องการยกเลิก',

  customRealTime: 'เรียลไทม์',
  customRealTimeSettings: 'การตั้งค่าเรียลไทม์',
  customModel: 'รุ่น',
  customSystemVersion: 'เวอร์ชันระบบ',
  customWebMarkerIcon: 'ไอคอน',
  customWebMarkerSetting: 'การตั้งค่าเครื่องหมาย',
  customWebMarkerName: 'ชื่อเครื่องหมาย',
  customWebMarkerColor: 'สีเครื่องหมาย',

  customRealtimeChooseYourDevice: 'กรุณาเลือกอุปกรณ์ของคุณ',
  customRealtimeDeviceNotActive: 'ไม่ได้ใช้งานอยู่ในขณะนี้',
  customElevation: 'ระดับความสูง',
  customGnss: 'GNSS',
  customSatellites: 'ดาวเทียม',

  customFirmwareVersion: 'เวอร์ชันเฟิร์มแวร์',
  customHasFirmwareUpdate: 'มีอัปเดตล่าสุด',
  customFirmwareDownloadMessage: 'มีเวอร์ชันใหม่ {newestFirmwareVersion} ออกมาแล้ว',
  customDownload: 'ดาวน์โหลด',

  customFieldRegistration: 'ลงทะเบียนฟิลด์ใหม่',
  customFieldCreateWithMapTitle: 'สร้างฟิลด์บนแผนที่',
  customFieldCreateWithMapTitleDescription: 'สร้างฟิลด์ใหม่บนแผนที่',
  customFieldCreateWithMapButton: 'สร้าง',

  customFieldCreateWithMapFieldName: 'ชื่อแปลง',
  customFieldCreateWithMapLoadingMap: 'กำลังโหลดแผนที่',
  customFieldCreateWithMapCreate: 'สร้าง',
  customFieldCreateWithMapCreateFinishedMessage: 'สร้างฟิลด์ {fieldName} แล้ว',
  customFieldCreateWithMapCreateErrorMessage: 'ไม่สามารถสร้างฟิลด์ {fieldName} ได้',
  customFieldCreateWithMapNoFieldMessage: 'กรุณาสร้างฟิลด์บนแผนที่',
  customFieldCreateWithMapNoFieldNameMessage: 'กรุณากรอกชื่อฟิลด์',
  customFieldCreateWithMapTooManyFieldsMessage: 'สามารถสร้างฟิลด์ได้เพียงฟิลด์เดียวเท่านั้น',

  customFieldUploadTitle: 'อัปโหลด KML/Shapefile',
  customFieldUploadMessage: 'กรุณาอัปโหลดไฟล์ KML/KMZ หรือ Shapefile ที่คุณมี',
  customFileUploadShapefileDescription: 'Shapefile ต้องการไฟล์เก็บถาวร ZIP (บีบอัด) ที่มีไฟล์ต่อไปนี้',
  customFieldUploadFileInput: 'เลือกไฟล์',

  customFileUploadShpDescription: '.shp (ข้อมูลรูปร่าง)',
  customFileUploadShxDescription: '.shx (ข้อมูลดัชนี)',
  customFileUploadDbfDescription: '.dbf (ข้อมูลแอตทริบิวต์)',
  customFileUploadPrjDescription: '.prj (ข้อมูลระบบพิกัดทางภูมิศาสตร์)',
  customFileUploadPrjCaution: 'ต้องใช้ .prj เพื่ออ่านข้อมูลพิกัดอย่างถูกต้อง',

  customFileUploadTextEncodingDescription: 'เปลี่ยนแปลงหากชื่อแอตทริบิวต์เป็นต้นแสดงผลเป็นภาษาต่างดาว',
  customFileUploadAttributeNameForFieldName: 'ชื่อแอตทริบิวต์ที่จะใช้เป็นชื่อฟิลด์',
  customFieldUploadFieldImportStart: 'เริ่มนำเข้า {count} ฟิลด์',
  customFileUploadImportCheckTitle: 'นำเข้า',
  customFileUploadFieldImportStartedMessage:
    'การนำเข้าฟิลด์เริ่มต้นขึ้นแล้ว หากมีฟิลด์จำนวนมาก อาจใช้เวลาสองสามนาทีในการดำเนินการ',
  customFieldUploadErrorMessage: 'ไม่สามารถอ่านไฟล์ที่อัปโหลดได้',

  customFieldThisFieldName: 'ฟิลด์ "{fieldName}"',
  customFieldUnknownFieldName: 'ฟิลด์นี้',
  customFieldNoName: 'ไม่มีฟิลด์',

  customFieldDeleteAlertWithTask:
    'มีประวัติการทำงาน {count} รายการใน {fieldName} หากคุณลบ ประวัติการทำงานที่เกี่ยวข้องในข้อมูลฟิลด์จะหายไป คุณแน่ใจหรือไม่ว่าต้องการลบ',
  customFieldDeleteAlertWithoutTask: 'คุณแน่ใจหรือไม่ว่าต้องการลบ {fieldName}',

  customTextEncoding: 'การเข้ารหัสข้อความ',

  customFieldImportFinishedMessage: 'นำเข้า {count} ฟิลด์สำเร็จแล้ว',
  customFieldImportErrorMessage: 'ไม่สามารถนำเข้าฟิลด์ได้',

  customFieldCount: 'จำนวนฟิลด์: {count} ฟิลด์',

  customExport: 'ส่งออก',
  customTaskExport: 'ส่งออกประวัติการทำงาน',
  customTaskWhatIsAgriBusFormat: 'รูปแบบ AgriBus เป็นข้อความที่คั่นด้วย TAB ดังนั้นจึงง่ายต่อการประมวลผล',
  customTaskNowDeveloping: 'กำลังพัฒนา',
  customTaskNowDevelopingDescription: 'คุณจะสามารถส่งออกในรูปแบบอื่นๆ ได้ในไม่ช้า',
  customTaskStartExporting: 'เริ่มส่งออก',
  customTaskNowExporting: 'กำลังส่งออก...',
  customTaskDownloadReady: 'พร้อมดาวน์โหลดแล้ว',

  // New
  customFieldHeader: 'แปลง',
  customDarkMode: 'โหมดมืด',
  customNewRegistration: 'ลงทะเบียนใหม่',
  customCreateNew: 'สร้างใหม่',
  customImport: 'นำเข้า',
  customListDisplay: 'การแสดงรายการ',
  customCardDisplay: 'การแสดงบัตร',
  customCalendarDisplay: 'การแสดงปฏิทิน',
  customFieldsList: 'รายการแปลง',

  customPleaseSignUpFromAndroidApplication:
    'กรุณาลงชื่อออกจากแอปพลิเคชัน Android <span class="aid-logotype">AgriBus-NAVI</span>',
  customWhatIsAgribusNAVI: '<span class="aid-logotype">AgriBus-NAVI</span> คือ',
  customAgriBusNAVIDescription:
    '<span class="aid-logotype">AgriBus-NAVI</span> เป็นแอปพลิเคชันแนะนำ GPS (คำแนะนำ GNSS) สำหรับ Android OS ที่ติดตั้งบนเครื่องจักรกลการเกษตรและยานพาหนะทางการเกษตร เช่น รถแทรกเตอร์ รถเกี่ยวข้าว และรถฉีดพ่นแบบขับเคลื่อนด้วยตัวเอง เพื่อช่วยในการทำงานเป็นเส้นตรงภายในฟิลด์ การติดตั้งบนสมาร์ทโฟนหรือแท็บเล็ตของคุณและขับรถในขณะที่ตรวจสอบหน้าจอแสดงผล ช่วยให้คุณสามารถทำงานทางการเกษตรได้อย่างตรงไปตรงมาและห่างกันอย่างเท่าเทียมกันในทุ่งกว้าง',

  customProductDetails: 'ดูรายละเอียดสินค้า',

  aid: {
    calendar: { month: 'เดือน', week: 'สัปดาห์', day: 'วัน', fourDays: '4 วัน' },
  },

  customTaskFilterAllSelect: 'งานทั้งหมด',

  customTaskFilterGetError: 'ไม่สามารถรับข้อมูลตัวกรองได้',
  customTaskFilterPostError: 'ไม่สามารถลงทะเบียนข้อมูลตัวกรองได้',
  customTaskFilterPutError: 'ไม่สามารถอัปเดตข้อมูลตัวกรองได้',
  customTaskFilterDeleteError: 'ไม่สามารถลบข้อมูลตัวกรองได้',

  customTaskFilterPostSucceed: 'ลงทะเบียน "{filtername}" แล้ว',
  customTaskFilterPutSucceed: 'อัปเดต "{filtername}" แล้ว',
  customTaskFilterSetDefault: 'ตั้งค่า "{filtername}" เป็นตัวกรองเริ่มต้นแล้ว',
  customTaskFilterDeleteSucceed: 'ลบข้อมูลตัวกรองแล้ว',

  customTaskFilterSelectCheckError: 'ไม่มีตัวกรองดังกล่าว กรุณาเลือกตัวกรอง',
  customTaskFilterDuplicateCheckError: 'ชื่อตัวกรองซ้ำกัน',
  customTaskFilterNotEnteredCheckError: 'ไม่ได้ป้อนชื่อตัวกรอง',

  customTaskFilterStringNarrowing: 'การจำกัดสตริง',
  customTaskFilterMakeDefault: 'ใช้ตัวกรองนี้เสมอ',
  customTaskFilterName: 'ชื่อตัวกรอง',
  customTaskFilterDeleteMsg: 'คุณต้องการลบ "{filtername}" หรือไม่',

  customTaskFilterDialogTitle1: 'กรองประวัติการทำงาน',
  customTaskFilterDialogTitle2: 'ใช้การตั้งค่าตัวกรองที่บันทึกไว้',
  customTaskFilterCreateNew: 'สร้างการตั้งค่าตัวกรองใหม่',
  customTaskFilterEdit: 'แก้ไขตัวกรอง',
  customTaskFilterSetting: 'การตั้งค่าตัวกรอง',
  customTaskFilterCurrent: 'ตัวกรองปัจจุบัน',
  customTaskFilterNoTasksError: 'จำนวนรายการที่แสดงเป็น 0 เนื่องจากการตั้งค่าของตัวกรอง "{filtername}"',
  customTaskFilterAreaZeroHidden: 'ไม่รวมงานที่มีพื้นที่ทำงาน (เติมสี) เป็นศูนย์',
  customTaskFilterDistanceUnderTenHidden: 'ไม่รวมงานที่มีระยะทางน้อยกว่า 10 ม. (10.936 หลา)',
  customTaskFilterNoField: 'ไม่มีฟิลด์',
  customTaskFilterNoCrop: 'ไม่มีการเพาะปลูก',
  customTaskFilterOutOfFieldHidden: 'ไม่รวมประวัติการทำงานนอกฟิลด์',

  customSimpleSignUpNow: 'กำลังลงทะเบียน...',
  customSimpleSignUpSuccess: 'ส่งอีเมลเพื่อยืนยันการลงทะเบียนแล้ว กรุณาตรวจสอบกล่องจดหมายของคุณ',
  customEnterpriseInviteSuccess: 'ส่งอีเมลเชิญแล้ว',
  customSimpleSignUpFailed: 'การลงทะเบียนล้มเหลว',
  customSimpleSignUpUserAlreadyExists: 'มีปัญหากับที่อยู่อีเมล',
  customSimpleSignUpServerError: 'เกิดข้อผิดพลาดในกระบวนการลงทะเบียน',

  customDateFilterStartDate: 'วันที่เริ่มต้นตัวกรอง',
  customDateFilterEndDate: 'วันที่สิ้นสุดตัวกรอง',
  customDateFilterCalendarType: 'ประเภทปฏิทิน',
  customDateFilterCalendarTypeDate: 'วัน',
  customDateFilterCalendarTypeMonth: 'เดือน',
  customDateFilterSetBotton: 'ตั้งค่า',
  customDateFilterRangeError: 'วันที่เริ่มต้นคือวันที่ในอนาคตของวันที่สิ้นสุด กรุณาเลือกวันที่อีกครั้ง',

  customCurrency: 'สกุลเงิน',

  customBillingCurrencyJPY: 'เยนญี่ปุ่น',
  customBillingCurrencyUSD: 'ดอลลาร์สหรัฐ',
  customBillingPurchase: 'ลองใช้ฟรี 30 วัน',
  customBillingPurchaseWithoutTrial: 'อัปเกรด',

  customBillingPlanInfo: 'ข้อมูลแผน',
  customBillingNowPlan: 'แผนปัจจุบัน',
  customBillingTrial: 'ทดลองใช้',
  customBillingCancellation: 'ยกเลิก',
  customBillingContractPeriod: 'ระยะเวลาสัญญา',
  customBillingAmount: 'จำนวนเงิน',
  customBillingAlertMustRegisterCard: 'ต้องลงทะเบียนบัตรเครดิตก่อนจึงจะซื้อได้',
  customBillingMessageUnsubscribe: 'ยกเลิกแผนแบบชำระเงินแล้ว',
  customBillingMessageSubscribe: 'ขอขอบคุณที่ซื้อ',
  customBillingMessageUnSubscribeGoogle:
    'ขณะนี้คุณได้สมัครใช้งานผ่าน Google Play Store แล้ว กรุณายกเลิกการสมัครของคุณใน Google Play Store',
  customBillingReceipt: 'ใบแจ้งหนี้ / ใบเสร็จรับเงิน',
  customBillingMessageCancelStandardPlan:
    'แม้ว่าคุณจะยกเลิกแผนแบบชำระเงิน คุณยังสามารถใช้บริการต่อไปได้จนกว่าจะถึงวันหมดอายุ หากคุณยกเลิกที่นี่ แผนของคุณจะเปลี่ยนเป็น Free Plan โดยอัตโนมัติหลังจาก {date} คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ',
  customBillingMessageCancelTrial:
    'ขณะนี้คุณอยู่ในช่วงทดลองใช้ หากคุณยกเลิกที่นี่ แผนของคุณจะเปลี่ยนกลับเป็น Free Plan ทันที โปรดทราบว่าคุณสามารถสมัครสมาชิกแผนแบบชำระเงินใหม่ได้หลังจากยกเลิก แต่จะไม่มีช่วงทดลองใช้',
  customBillingStandardDescription:
    'แผนแบบชำระเงินเป็นแผนรายปีพร้อมทดลองใช้ฟรี 1 เดือน ใช้ประโยชน์จากฟังก์ชันทั้งหมด เช่น การบันทึกข้อมูล AgriBus-Web โดยไม่จำกัด และการแสดงตำแหน่งยานพาหนะแบบเรียลไทม์ การบันทึกและการเรียกคืนเส้นแนะนำ และเส้นโค้งใน AgriBus-NAVI!',

  customBillingMenu: 'จัดการแผนการใช้งานของคุณ',
  customBillingMore: 'เรียนรู้เพิ่มเติม',

  customAdRow1_1: 'ด้วย Standard Plan',
  customAdRow1_2: 'การปฏิวัติข้อมูลสำหรับงานเกษตร',

  customAdRow2_1: '3 ข้อดี',
  customAdRow2_2: 'จัดเก็บและส่งออกข้อมูลได้ไม่จำกัด',
  customAdRow2_3: 'การแสดงตำแหน่งยานพาหนะแบบเรียลไทม์',
  customAdRow2_4: 'การใช้ AgriBus-Caster',

  customAdRow3_1: '3 ข้อดี',
  customAdRow3_2: 'เพิ่มระดับความสูง ความเร็วในการเดินทาง ฯลฯ ลงในเส้นทางการทำงาน',
  customAdRow3_3: 'บันทึกและเรียกคืนเส้นแนะนำ',
  customAdRow3_4: 'การใช้เส้นโค้ง',

  customOAuthMessage: 'กำลังตรวจสอบสิทธิ์...',
  customGoogleOAuthBtn: 'เข้าสู่ระบบด้วย Google',
  customGoogleOAuthSignUpBtn: 'ลงชื่อสมัครใช้ด้วย Google',
  customOAuthError: 'เกิดข้อผิดพลาดในกระบวนการตรวจสอบสิทธิ',
  customOAuthGetUserInfoError: 'เกิดข้อผิดพลาดในการรับข้อมูล OAuth',
  customOAuthServerError: 'เกิดข้อผิดพลาดในกระบวนการลงทะเบียนข้อมูลการตรวจสอบสิทธิ์ OAuth',
  customOAuthFailed: 'การตรวจสอบสิทธิ์ OAuth ล้มเหลว',

  customToBillingPage: 'ไปที่หน้าซื้อ Standard Plan',
  customTasksListFreePlanMsg:
    'ใน Free Plan ประวัติการทำงานจะแสดงเพียง 2 วันเท่านั้น คุณสามารถทำให้ระยะเวลาการจัดเก็บไม่จำกัดโดยการสมัครสมาชิก Standard Plan',

  customEnterprise: 'องค์กร',
  customEnterpriseSetting: 'การตั้งค่าองค์กร',
  customEnterpriseManagement: 'การจัดการองค์กร',
  customWhatIsEnterprise: 'AgriBus-Web Enterprise คืออะไร',
  customEnterpriseRegistration: 'ลงทะเบียนสำหรับแผนองค์กร',
  customPleaseContinueToRegisterForEnterprise:
    'กรุณาดำเนินการลงทะเบียนสำหรับ AgriBus-Web Enterprise ต่อจากอีเมลที่คุณได้รับ',
  customPleaseInputOrganizationName: 'กรุณากรอกชื่อองค์กรของคุณ',
  customEnterpriseName: 'ชื่อองค์กร',
  customMaxOfMemberThisMonth: 'จำนวนสมาชิกสูงสุดของเดือนนี้',
  customExpectedPaymentAmountForThisMonth: 'จำนวนเงินที่คาดว่าจะชำระในเดือนนี้',
  customDateOfPayment: 'วันที่ชำระเงิน',
  customPaymentHistory: 'ประวัติการชำระเงิน',
  customEditEnterpriseName: 'แก้ไขชื่อองค์กร',
  customOrganization: 'องค์กร',
  customOrganizationName: 'ชื่อองค์กร',
  customAdministrator: 'ผู้ดูแลระบบ',
  customOrganizationList: 'รายชื่อองค์กร',
  customNewOrganization: 'สร้างองค์กรใหม่',
  customCreateOrganization: 'สร้างองค์กร',
  customEditOrganizationName: 'แก้ไขชื่อองค์กร',
  customTeam: 'ทีม',
  customTeamList: 'รายชื่อทีม',
  customMyTeam: 'ทีมของฉัน',
  customMyTeamList: 'รายชื่อทีมของฉัน',
  customNewTeam: 'สร้างทีมใหม่',
  customTeamName: 'ชื่อทีม',
  customCreateTeam: 'สร้างทีม',
  customRemoveFromTeam: 'ลบออกจากทีม',
  customEditTeam: 'แก้ไขทีม',
  customMember: 'สมาชิก',
  customMemberName: 'ชื่อสมาชิก',
  customAddNewMember: 'เพิ่มสมาชิก',
  customNumberOfMember: 'จำนวนสมาชิก',
  customInviteMembers: 'เชิญสมาชิก',
  customSendInvitationEmail: 'ส่งอีเมลเชิญ',
  customPleaseEnterTheNameOfTheMember: 'กรุณากรอกชื่อสมาชิกที่คุณต้องการเชิญ',
  customMemberList: 'รายชื่อสมาชิก',
  customEditMember: 'แก้ไขสมาชิก',
  customInviting: 'กำลังเชิญ',
  customRestrictFollow: 'จำกัดการติดตาม',
  customPermission: 'สิทธิ์การเข้าถึง',
  customPermissionName: 'ชื่อสิทธิ์การเข้าถึง',
  customRoleName: 'ชื่อบทบาท',
  customAction: 'การดำเนินการ',
  customIndividualCreation: 'การสร้างแบบรายบุคคล',
  customConfirmTeamDeletion: 'คุณแน่ใจหรือไม่ว่าต้องการลบทีมนี้',
  customConfirmMemberRemovalFromTeam: 'คุณแน่ใจหรือไม่ว่าต้องการลบสมาชิกนี้ออกจากทีม',
  customSelectTeamsForMemberToJoinDialogTitle: 'กรุณาเลือกทีมที่สมาชิกจะเข้าร่วม',
  customSelectTeamsForMemberToJoinDialogOK: 'เพิ่มในทีมที่เลือก',
  customSelectMembersAddToTeamDialogTitle: 'กรุณาเลือกสมาชิกที่จะเพิ่มในทีม',
  customSelectMembersAddToTeamDialogOK: 'เพิ่มสมาชิกที่เลือก',
  customFollowMembersDialogTitle: 'กรุณาเลือกสมาชิกที่จะติดตาม',
  customFollowMembersDialogOK: 'ติดตามสมาชิกที่เลือก',
  customTeamFollowSelectDialogTitle: 'กรุณาเลือกทีมที่จะติดตาม',
  customTeamFollowSelectDialogOK: 'ติดตามทีมที่เลือก',
  customPleaseConfirm: 'กรุณายืนยัน',
  customEnterpriseSignUpForPleaseConfirmDescription1:
    'ผู้ใช้ที่มีที่อยู่อีเมลที่ระบุเป็นสมาชิก Standard Plan หรือ Enterprise Plan',
  customEnterpriseSignUpForPleaseConfirmDescription2:
    'หากเป็นสมาชิก Standard Plan กรุณายกเลิกการสมัครก่อนลงทะเบียนสำหรับ Enterprise Plan',
  customEnterpriseSignUpForFreePlanDescription:
    'ผู้ใช้ที่มีที่อยู่อีเมลที่ระบุเป็นสมาชิก Free Plan คุณต้องการเปลี่ยนเป็น Enterprise Plan หรือไม่',
  customEnterpriseSignUpForStandardPlanDescription:
    'ผู้ใช้ที่มีที่อยู่อีเมลที่ระบุได้ยกเลิก Standard Plan แล้ว แต่ยังอยู่ในช่วงเวลาที่สามารถใช้งานได้ คุณต้องการเปลี่ยนเป็น Enterprise Plan หรือไม่ (โปรดทราบว่าหากคุณยังมียอดค้างชำระสำหรับ Standard Plan คุณจะถูกเรียกเก็บเงินสำหรับทั้ง Standard Plan และ Enterprise Plan)',
  customAddFollowMembers: 'เพิ่มสมาชิกที่ติดตาม',
  customAddFollowTeams: 'เพิ่มทีมที่ติดตาม',
  customBillingMaxMember: 'จำนวนสมาชิกสูงสุด',
  customCreditCardRegistration: 'การลงทะเบียนบัตรเครดิต',
  customNext: 'ถัดไป',
  customGoBackOneStep: 'ย้อนกลับหนึ่งขั้นตอน',
  customRestriction: 'ข้อจำกัด',
  customMemberSuspension: 'คุณแน่ใจหรือไม่ว่าต้องการระงับสมาชิกนี้',
  customResumeMemberUsage: 'คุณแน่ใจหรือไม่ว่าต้องการดำเนินการใช้งานสมาชิกนี้ต่อ',
  customRestart: 'เริ่มต้นใหม่',
  customSuspended: 'ถูกระงับ',
  customAddToExistingTeam: 'เพิ่มในทีมที่มีอยู่',
  customFollowFunction: 'ฟังก์ชันการติดตาม',
  customAllowToAddAndRemoveFollow: 'อนุญาตให้เพิ่มและลบการติดตาม',
  customAllowToAddAndRemoveFollowDescription: 'สมาชิกนี้ไม่สามารถเพิ่มหรือลบการติดตามได้อย่างอิสระ',
  customNotAllowToAddAndRemoveFollow: 'ไม่อนุญาตให้เพิ่มและลบการติดตาม',
  customNotAllowToAddAndRemoveFollowDescription: 'สมาชิกนี้สามารถเพิ่มหรือลบการติดตามได้อย่างอิสระ',
  customEnterprisePlanDisplayName: 'Enterprise Plan',
  customPricePerMember: 'ราคาต่อสมาชิก 1 คน',
  customPerMember: 'ต่อสมาชิก 1 คน',
  customNotesOnPlanSelection: 'จำนวนเงินที่เรียกเก็บคือจำนวนสมาชิกสูงสุดภายในเดือนที่เรียกเก็บเงินคูณด้วยราคาต่อหน่วย',
  customDueDateForFirstRepayment: 'วันที่ชำระเงินครั้งแรก',
  customEnterprisePlanStart: 'เริ่มใช้งาน',
  customUnsubscribeFromEnterprise: 'ถอนตัวจาก Enterprise Plan',
  customReturnAgriBusWeb: 'กลับไปที่ Agri-Bus Web',
  customAboutCreditCardPayment: 'เกี่ยวกับบัตรเครดิตที่คุณใช้ชำระเงิน',
  customClickHereUnsubscripbeFromEnterprise: 'คลิกที่นี่เพื่อถอนตัวจาก Enterprise Plan',
  customEnterpriseWithdrawText1:
    'การถอนตัวจะทำให้การเรียกเก็บเงินสำหรับเดือนนี้เป็นครั้งสุดท้าย และจะไม่มีการเรียกเก็บเงินอีกต่อไป',
  customEnterpriseWithdrawText2: 'เราจะพัฒนาผลิตภัณฑ์ AgriBus ซีรีส์ต่อไป ดังนั้นโปรดกลับมาดูอีกครั้งเมื่อคุณมีโอกาส',
  customEnterpriseWithdrawText3:
    'เราขอขอบคุณอย่างจริงใจที่คุณใช้ผลิตภัณฑ์ AgriBus ซีรีส์ แม้จะเป็นช่วงเวลาสั้นๆ ขอบคุณที่ใช้บริการของเรา',
  customErrorEnterpriseWithdraw: 'ไม่สามารถยกเลิก Enterprise Plan ได้ กรุณาลองใหม่อีกครั้ง',
  customGuidanceInterval: 'ช่วงแนะนำ',
  customWorkingWidth: 'ความกว้างในการทำงาน',
  customRefLineLength: 'ความยาวเส้นฐานสำหรับวิ่ง',
  customRefLine: 'เส้นฐานสำหรับวิ่ง',
  customExportRefLine: 'ส่งออกเส้นฐานสำหรับวิ่ง',
  customDirecton: 'ทิศทาง',
  customShowTaskDetailError: 'ไม่มีประวัติการทำงาน อาจไม่ได้ซิงโครไนซ์หรือถูกลบใน AgriBus-NAVI',
  customFileUploadAttributeNameForRefLineName: 'ชื่อแอตทริบิวต์ที่จะใช้เป็นเส้นฐานสำหรับวิ่ง',
  customFileUploadRefLineImportStart: 'เริ่มนำเข้า {count} เส้นฐานสำหรับวิ่ง',
  customFileUploadShapefileDescriptionForRefLines:
    'Shapefile ต้องการไฟล์เก็บถาวร ZIP (บีบอัด) ที่ประกอบด้วยไฟล์ต่อไปนี้เท่านั้น',
  customFileUploadShpDescriptionForRefLines: 'Swaths.shp (ข้อมูลรูปร่าง)',
  customFileUploadShxDescriptionForRefLines: 'Swaths.shx (ข้อมูลดัชนี)',
  customFileUploadDbfDescriptionForRefLines: 'Swaths.dbf (ข้อมูลแอตทริบิวต์)',

  customRefLineImportFinishedMessage: 'นำเข้า {count} เส้นฐานสำหรับวิ่งสำเร็จแล้ว',
  customRefLineImportErrorMessage: 'ไม่สามารถนำเข้าเส้นฐานสำหรับวิ่งได้',
  customRefLineAddTitle: 'ลงทะเบียนเส้นฐานสำหรับวิ่งใหม่',
  customRefLineImportTitle: 'อัปโหลด Shapefile',
  customRefLineImportText: 'กรุณาอัปโหลด Shapefile ที่คุณมี',
  customRefLineImportText2: 'สามารถนำเข้าเฉพาะเส้นฐานสำหรับวิ่งที่ส่งออกจาก Trimble CFX-750 เท่านั้น',
  customRefLineCreateTitle: 'สร้างเส้นฐานสำหรับวิ่งบนแผนที่',
  customRefLineCreateText: 'สร้างเส้นฐานสำหรับวิ่งบนแผนที่',
  customRefLineUploadTitle: 'อัปโหลดเส้นฐานสำหรับวิ่ง',
  customRefLineNameHint: 'ชื่อเส้นฐานสำหรับวิ่ง',
  customRefLineDeleteAlert: 'คุณแน่ใจหรือไม่ว่าต้องการลบ {refLineName}',
  customRefLineDeleteUnknownName: 'เส้นฐานสำหรับวิ่งนี้',
  customRefLineDeleteKnownName: 'เส้นฐานสำหรับวิ่ง "{refLineName}"',
  customRefLineDeleteError: 'ไม่สามารถลบเส้นฐานสำหรับวิ่งได้',

  customThunderstormWithLightRain: 'ฝนฟ้าคะนองมีฝนตกเล็กน้อย',
  customThunderstormWithRain: 'ฝนฟ้าคะนอง',
  customThunderstormWithHeavyRain: 'ฝนฟ้าคะนองมีฝนตกหนัก',
  customThunderstormWithLightDrizzle: 'ฝนฟ้าคะนองมีฝนปรอยๆ เล็กน้อย',
  customThunderstormWithDrizzle: 'ฝนฟ้าคะนองมีฝนปรอยๆ',
  customThunderstormWithHeavyDrizzle: 'ฝนฟ้าคะนองมีฝนตกปรอยๆ หนัก',
  customThunderstormWithHail: 'ฝนฟ้าคะนองมีลูกเห็บ',
  customLightDrizzle: 'ฝนตกปรอยๆ เล็กน้อย',
  customDrizzle: 'ฝนปรอยๆ',
  customHeavyDrizzle: 'ฝนตกปรอยๆ หนัก',
  customLightRain: 'ฝนตกเล็กน้อย',
  customModerateRain: 'ฝนปานกลาง',
  customHeavyRain: 'ฝนตกหนัก',
  customFreezingRain: 'ฝนเยือกแข็ง',
  customLightShowerRain: 'ฝนตกเบาบาง',
  customShowerRain: 'ฝนตกเป็นช่วงๆ',
  customHeavyShowerRain: 'ฝนตกหนักเป็นช่วงๆ',
  customLightSnow: 'หิมะตกเล็กน้อย',
  customSnow: 'หิมะตก',
  customHeavySnow: 'หิมะตกหนัก',
  customMixSnowRain: 'ฝนผสมหิมะ',
  customSleet: 'ลูกเห็บ',
  customHeavySleet: 'ลูกเห็บตกหนัก',
  customSnowShower: 'หิมะตกเป็นช่วงๆ',
  customHeavySnowShower: 'หิมะตกหนักเป็นช่วงๆ',
  customFlurries: 'หิมะตกโปรยปราย',
  customMist: 'หมอกบาง',
  customSmoke: 'ควัน',
  customHaze: 'หมอกควัน',
  customSandDust: 'ฝุ่นทราย',
  customFog: 'หมอก',
  customFreezingFog: 'หมอกจัด',
  customClearSky: 'ท้องฟ้าแจ่มใส',
  customFewClouds: 'มีเมฆบางส่วน',
  customScatteredClouds: 'มีเมฆกระจัดกระจาย',
  customBrokenClouds: 'มีเมฆมาก',
  customOvercastClouds: 'มีเมฆมาก',
  customUnknownPrecipitation: 'หยาดน้ำฟ้าที่ไม่ทราบประเภท',
  customWeatherInfoTitle: 'ข้อมูลสภาพอากาศในขณะทำงานนี้',
  customWeatherDescriptionTitle: 'สภาพอากาศ',
  customWindSpeedTitle: 'ความเร็วลม',
  customTemperatureTitle: 'อุณหภูมิ',
  customRelativeHumidityTitle: 'ความชื้นสัมพัทธ์',
  customPrecipitationTitle: 'ปริมาณน้ำฝน',
  customNumOfSatellites: 'จำนวนดาวเทียมที่ใช้ในการระบุตำแหน่ง',
  customGnssStatus: 'สถานะ GNSS',
  customLeftRightMisalignment: 'ระยะห่างจากซ้ายไปขวา',
  customAzimuthShift: 'การเลื่อนแนวราบ',
  customGradient: 'ความลาดชัน',
  customTimeOfAcquisition: 'เวลาที่ได้รับ',
  customWorkOverview: 'ภาพรวมงาน',
  customImageStorage: 'ที่จัดเก็บรูปภาพ',
  customMapGaugeDescriptionNone: 'พื้นที่ทำงานที่ไม่มีการเติมสีจะปรากฏขึ้น',
  customMapGaugeDescriptionHeight: 'ระดับความสูงของงานจะแสดงเป็นสีต่างๆ',
  customMapGaugeDescriptionSpeed: 'ความเร็วในการทำงานจะแสดงเป็นสีต่างๆ',
  customMapGaugeDescriptionNumOfSatellites: 'จำนวนดาวเทียมที่ใช้ในการระบุตำแหน่งในขณะทำงานจะแสดงเป็นสีต่างๆ',
  customMapGaugeDescriptionGnssStatus: 'สถานะ GNSS ในขณะทำงานจะแสดงเป็นสีต่างๆ',
  customMapGaugeDescriptionLeftRightMisalignment: 'ระยะห่างจากซ้ายไปขวาจากคำแนะนำในขณะทำงานจะแสดงเป็นสีต่างๆ',
  customMapGaugeDescriptionAzimuthShift: 'การเลื่อนแนวราบจากคำแนะนำในขณะทำงานจะแสดงเป็นสีต่างๆ',
  customMapGaugeDescriptionGradient: 'ความลาดชันในขณะทำงานจะแสดงเป็นสีต่างๆ (เฉพาะ G2, GMiniR, Gmini)',
  customWeathercomTornado: 'พายุทอร์นาโด',
  customWeathercomTropicalStorm: 'พายุโซนร้อน',
  customWeathercomHurricane: 'พายุไต้ฝุ่น',
  customWeathercomStrongStorms: 'พายุรุนแรง',
  customWeathercomThunderstorms: 'พายุฝนฟ้าคะนอง',
  customWeathercomRainSnow: 'ฝนและหิมะ',
  customWeathercomRainSleet: 'ฝนและลูกเห็บ',
  customWeathercomWintryMix: 'หิมะผสมฝน',
  customWeathercomFreezingDrizzle: 'ฝนตกปรอยๆ เยือกแข็ง',
  customWeathercomDrizzle: 'ฝนตกปรอยๆ',
  customWeathercomFreezingRain: 'ฝนเยือกแข็ง',
  customWeathercomShowers: 'ฝนตกเป็นช่วงๆ',
  customWeathercomRain: 'ฝนตก',
  customWeathercomFlurries: 'หิมะตกเล็กน้อย',
  customWeathercomSnowShowers: 'หิมะตกเป็นช่วงๆ',
  customWeathercomBlowingDriftingSnow: 'พายุหิมะ',
  customWeathercomSnow: 'หิมะตก',
  customWeathercomHail: 'ลูกเห็บ',
  customWeathercomSleet: 'ลูกเห็บน้ำแข็ง',
  customWeathercomBlowingDustSandstorm: 'พายุฝุ่น',
  customWeathercomFoggy: 'หมอกลง',
  customWeathercomHaze: 'หมอกควัน',
  customWeathercomSmoke: 'ควัน',
  customWeathercomBreezy: 'ลมโชย',
  customWeathercomWindy: 'ลมแรง',
  customWeathercomFrigidIceCrystals: 'ผลึกน้ำแข็ง',
  customWeathercomCloudy: 'มีเมฆมาก',
  customWeathercomMostlyCloudy: 'มีเมฆเป็นส่วนใหญ่',
  customWeathercomPartlyCloudy: 'มีเมฆบางส่วน',
  customWeathercomClear: 'ท้องฟ้าแจ่มใส',
  customWeathercomSunny: 'แดดจัด',
  customWeathercomFairMostlyClear: 'แจ่มใส',
  customWeathercomFairMostlySunny: 'แดดจัด',
  customWeathercomMixedRainandHail: 'ฝนและลูกเห็บ',
  customWeathercomHot: 'อากาศร้อนจัด',
  customWeathercomIsolatedThunderstorms: 'ฝนฟ้าคะนองเป็นบางแห่ง',
  customWeathercomScatteredThunderstorms: 'ฝนฟ้าคะนองเป็นบางแห่ง',
  customWeathercomScatteredShowers: 'ฝนตกเป็นแห่งๆ',
  customWeathercomHeavyRain: 'ฝนตกหนัก',
  customWeathercomScatteredSnowShowers: 'หิมะตกเป็นแห่งๆ',
  customWeathercomHeavySnow: 'หิมะตกหนัก',
  customWeathercomBlizzard: 'พายุหิมะ',
  customWeathercomNotAvailable: 'ไม่สามารถรับสภาพอากาศได้',

  customSharedMountPointSetting: 'การตั้งค่าจุดเชื่อมต่อ',
  customSharedMountPointSettingTitle: 'ตั้งค่าจุดเชื่อมต่อสำหรับสถานีฐาน RTK ที่จะแชร์ภายในองค์กร',
  customSharedMountPoint: 'จุดเชื่อมต่อที่แชร์',
  customMountPoint: 'จุดเชื่อมต่อ',
  customStatus: 'สถานะ',
  customNotSet: 'ไม่ได้ตั้งค่า',
  customSelectMountPoint: 'เลือกจุดเชื่อมต่อ',
  customUnsharedMountPoint: 'ยกเลิกการแชร์',
  customSelectMountPointTitle: 'กรุณาเลือกจุดเชื่อมต่อที่จะแชร์',
  customSharedMountPointRemarks1:
    'จุดเชื่อมต่อจะออกเมื่อตั้งค่า AgriBus-GMiniR เป็นสถานีฐานโดยใช้แอป AgriBus-GTools หากคุณใช้สถานีฐานของบริษัทอื่น กรุณาสมัครจากลิงก์ด้านล่าง',
  customSharedMountPointRemarks2: 'สมัครได้ที่นี่',
  customOnline: 'ออนไลน์',
  customOffline: 'ออฟไลน์',
  customNotIssued: 'ยังไม่ออก',
  customSetItUp: 'ตั้งค่าแล้ว',
  customDeActivated: 'ปิดใช้งานแล้ว',
  customType: 'ประเภท',
  customCropIsNotRegistered: 'ไม่ได้ลงทะเบียนการปลูกพืช',
  customNameNotRegistered: 'ยังไม่ได้ลงทะเบียนชื่อ',

  customGoToPayerManager: 'เปิดแผงควบคุม',
  customPaymentInfo: 'ข้อมูลการชำระเงิน',
  customProjectInfo: 'ข้อมูลโครงการ',
  customAddProject: 'เพิ่มโครงการ',
  customAddProjectRemarks: 'กรุณาระบุชื่อโครงการและที่อยู่อีเมลของผู้ดูแลระบบ',
  customProjectName: 'ชื่อโครงการ',
  customProjectAdminMailAddress: 'ที่อยู่อีเมลของผู้ดูแลระบบ',
  customStop: 'หยุด',
  customStopDialogText: 'คุณต้องการลบโครงการที่เลือกหรือไม่',
  customDone: 'เสร็จสิ้น',
  customUpdateDay: 'วันที่อัปเดต',
  customAdminName: 'ชื่อผู้ดูแลระบบ',
  customMaxQuantity: 'จำนวนสูงสุดของคน',
  customaddProjectSuccess: 'การเพิ่มโครงการเสร็จสมบูรณ์แล้ว',
  customPlantingShowPast: 'แสดงการปลูกพืชที่ผ่านมา',
  customPlantingHidePast: 'ซ่อนการปลูกพืชที่ผ่านมา',
  customPlantingCropDisplayName: 'ชื่อที่แสดงผลของพืช',
  customPlantingCropVarietyName: 'ชื่อพันธุ์',
  customPlantingSeason: 'ฤดูปลูก',
  customPlantingSeasonStartDate: 'วันที่เริ่มต้น (จำเป็น)',
  customPlantingSeasonEndDate: 'วันที่สิ้นสุด',
  customPlantingAddCropOption: 'เพิ่มตัวเลือกพืชผล',
  customPlantingRemoveCropOption: 'ลบตัวเลือกพืชผล',
  customPlantingCropSelectionRequiredError: 'กรุณาเลือก หากไม่พบรายการที่ตรงกัน กรุณาเลือก "อื่นๆ"',
  customPlantingOtherCropSelectionRequiredError: 'กรุณากรอกข้อมูลเมื่อเลือก "อื่นๆ"',
  customPlantingDeleteConfirmationMessage:
    "คุณแน่ใจหรือไม่ว่าต้องการลบ {plantingName} (ข้อมูลที่เกี่ยวข้องจะถูกลบด้วย)'",
  customPlantingFieldSelectionHint: 'รายการนี้จะไม่ปรากฏขึ้นหากไม่ได้ตั้งชื่อฟิลด์',

  customTaskDeleteMessage: 'คุณแน่ใจหรือไม่ว่าต้องการลบงานที่เลือก',
  customTaskDeleteFailure: 'ไม่สามารถลบงานที่เลือกได้',
  customTaskDeleteSucceed: 'ลบงานที่เลือกสำเร็จแล้ว',

  customErrorStartDateRequired: 'วันที่เริ่มต้นเป็นข้อมูลบังคับ',
  customErrorFieldRequired: 'ต้องระบุฟิลด์',

  customAlreadyExistingUser: 'ที่อยู่อีเมลนี้ลงทะเบียนแล้ว กรุณาใช้ที่อยู่อีเมลที่ยังไม่ได้ลงทะเบียน',

  customNowProgressRateTitle: 'ความคืบหน้าของงาน',
  customNowProgressRateNotField: 'ไม่มีฟิลด์ที่ตรงกัน',

  customStandardSubscribeErrorMessage: 'การซื้อการสมัครสมาชิกล้มเหลว กรุณาตรวจสอบข้อมูลที่ป้อนอีกครั้ง',
  customStripeCouponText1: 'คลิกที่นี่หากต้องการใช้คูปอง',
  customStripeCouponText2: 'ป้อนรหัสคูปองที่นี่',

  customUpdatePolygonFailure: 'ไม่สามารถอัปเดตฟิลด์ได้',

  customMultiPolygonImportError: 'ข้อมูลนี้มี MultiPolygon ไม่รองรับ MultiPolygon ดังนั้นโปรดแปลงเป็น Polygon',

  customSimpleSignUpAndSignInError: 'มีปัญหากับที่อยู่อีเมลหรือรหัสผ่าน กรุณาตรวจสอบอีกครั้ง',
  customNewPasswordValidationError: 'ต้องมีตัวอักษรภาษาอังกฤษตัวพิมพ์เล็กและตัวเลขอย่างน้อยหนึ่งตัว',

  // 2022.12.08
  customSelectPlanSelectPaymentMethodText: 'เลือกวิธีการชำระเงิน',
  customCardInfoHasNotBeenEnteredError: 'กรุณากรอกข้อมูลบัตร',
  customNoPaymentMethodSeletedError: 'ไม่ได้เลือกวิธีการชำระเงิน',
  customFreeDashBoardText1: 'ต้องสมัครสมาชิกแผนแบบชำระเงิน (AgriBus Professional) เพื่อเข้าสู่ระบบ AgriBus-Web',
  customFreeDashBoardText2: 'สำหรับรายละเอียด',
  customFreeDashBoardText3: 'ประกาศ',
  customFreeDashBoardText4: 'กรุณาตรวจสอบ',
  customContractPlanTitle: 'แผนบริการของคุณ',
  customComparePlansText: 'เปรียบเทียบแผน',
  customUpgradeToPlusText: 'อัปเกรดเป็น Plus',
  customDowngradeToPlusText: 'ดาวน์เกรดเป็น Plus',
  customUpgradeToProfessionalText: 'อัปเกรดเป็น AgriBus Professional',
  customBillingBillingText1: 'ยกเลิกแล้ว - จะเปลี่ยนเป็น Free Plan โดยอัตโนมัติเมื่อหมดอายุ',
  customUpgradeConfirematoinText: 'คุณต้องการอัปเกรดเป็น AgriBus Professional หรือไม่',
  customDowngradeConfiremationText: 'คุณต้องการดาวน์เกรดเป็น Plus หรือไม่',
  customBankTransfer: 'โอนเงินผ่านธนาคาร',
  customHome: 'หน้าแรก',
  customBillingMessageSubscribeGoogle:
    'ขณะนี้คุณได้สมัครใช้งานผ่าน Google Play Store แล้ว กรุณาอัปเกรด/ดาวน์เกรดการสมัครของคุณใน Google Play Store',
  customInvoiceReceiptAddresseeTitle: 'ชื่อผู้รับใบแจ้งหนี้/ใบเสร็จรับเงิน',
  customChangeAddresseeBtnText: 'เปลี่ยนชื่อผู้รับ',
  customBillingEmailAddressTitle: 'ที่อยู่อีเมลสำหรับการเรียกเก็บเงิน',
  customChangeBillingEmailAddressText: 'เปลี่ยนที่อยู่อีเมลสำหรับการเรียกเก็บเงิน',
  customCannotDowngradeText: 'ไม่สามารถดาวน์เกรดเป็น Plus ได้หากชำระเงินผ่านการโอนเงินผ่านธนาคาร',
  customChangePaymentMethodsToCard: 'เปลี่ยนเป็นการชำระเงินด้วยบัตร',
  customChangePaymentMethodsToCustomerBalance: 'เปลี่ยนเป็นการโอนเงินผ่านธนาคาร',
  customChangePaymentMethodToSendInvoiceText: 'คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนวิธีการชำระเงินเป็นการโอนเงินผ่านธนาคาร',
  customMapGaugeDescriptionColorCodedFill: 'ประวัติการทำงานที่เติมสีจะปรากฏขึ้นหากคุณเติมสีตามประเภทในแอป',
  customColorCodeFill: 'เติมสีตามประเภท',
  customSelectDefaultIconTitle: 'กรุณาเลือกไอคอน',
  customImportLimitMessage: 'สามารถนำเข้าได้สูงสุด {limit} รายการ',
  customPresetIcon: {
    title: 'ค่าที่ตั้งไว้',
    description: 'คุณสามารถเลือกได้จาก 6 ค่าที่ตั้งไว้',
    btnText: 'เลือกจากค่าที่ตั้งไว้',
  },
  customBulkDeleteCheckboxText: 'ลบจำนวนมาก',
  customBulkDeleteDialogText: 'คุณแน่ใจหรือไม่ว่าต้องการลบจำนวนมาก',
  customPerimeter: 'เส้นรอบวง',
  feed: {
    menu: 'ฟีด',
    title: 'ฟีดข่าว',
    description: 'สถิติกิจกรรมการเกษตรในภูมิภาค (ข้อมูลนิรนาม) และข่าวสารจากแหล่งเพาะปลูก อัปเดตทุกวัน',
    yourArea: 'กิจกรรมในพื้นที่ของคุณ (~33 กม.)',
    areaFromFields: 'ตรวจจับจากแปลงของคุณ',
    widerArea: 'พื้นที่กว้างขึ้น (~55 กม.)',
    national: 'กิจกรรมทั่วประเทศ',
    daily: 'เมื่อวาน',
    weekly: '7 วันล่าสุด',
    monthly: '28 วันล่าสุด',
    vsNormal: 'เทียบค่าปกติ',
    vsLastYear: 'เทียบปีที่แล้ว',
    noData: 'ข้อมูลในพื้นที่นี้ไม่เพียงพอ (มีการทำงานใกล้เคียงน้อยเกินไป)',
    noAreaHint: 'ลงทะเบียนแปลงของคุณเพื่อดูสถิติของพื้นที่',
    nationalFallback: 'แสดงสถิติทั่วประเทศด้านล่าง',
    upsell: 'แผนแบบชำระเงินเพิ่มหน้าต่างรายวันและ 28 วัน รวมถึงมุมมอง ~55 กม.',
    monitorTitle: 'รายงานรายสัปดาห์ของมอนิเตอร์',
    monitorActive: 'พบรูปแบบการสังเกต',
    monitorNone: 'ไม่มีรูปแบบการสังเกต',
    toMarketInsights: 'เปิด Market Insights',
    loadError: 'โหลดฟีดไม่สำเร็จ กรุณาลองใหม่ภายหลัง',
    disclaimer: 'กิจกรรมระดับภูมิภาคเป็นสถิตินิรนาม ไม่ใช่การประเมินฟาร์มรายแปลง',
    kindNews: 'ข่าวสาร',
    kindPr: 'PR',
    readMore: 'อ่านเพิ่มเติม',
    entryDaily: 'กิจกรรมงานวันที่ {date}',
    entryWeekly: 'สรุปรายสัปดาห์ (ถึง {date})',
    areaC3: 'พื้นที่ของคุณ',
    areaC5: 'พื้นที่กว้าง',
    areaJp: 'ทั่วประเทศ',
    historyTitle: 'แนวโน้มที่ผ่านมา',
    kindSignal: 'สัญญาณ',
    shareTitle: 'แชร์ไปยังฟีด',
    share: 'แชร์',
    shareVisibility: 'การมองเห็น',
    visFollowers: 'เฉพาะผู้ติดตาม',
    visNeighborhood: 'พื้นที่ใกล้เคียง',
    visPublic: 'สาธารณะ',
    shareRoute: 'แสดงเส้นทางการทำงาน',
    shareExact: 'แชร์ตำแหน่งจริงด้วย (พื้นหลังแผนที่)',
    statTime: 'เวลา',
    statDistance: 'ระยะทาง',
    statArea: 'พื้นที่',
    statWidth: 'ความกว้าง',
    statSpeed: 'ความเร็ว',
    statGnss: 'GNSS',
    shareComment: 'ความคิดเห็น',
    shareSubmit: 'แชร์',
    sharePosted: 'แชร์แล้ว',
    shareFailed: 'ไม่สามารถดำเนินการได้ โปรดลองอีกครั้งภายหลัง',
    consentNote: 'โพสต์ของคุณจะแสดงต่อผู้ใช้ตามขอบเขตที่เลือก ตำแหน่งจะแสดงเป็นพื้นที่โดยประมาณ (ราว 11 กม.) เท่านั้น',
    consentLabel: 'ยอมรับข้อกำหนดการแชร์ (ข้อ 15-2)',
    postDelete: 'ลบ',
    postDeleted: 'ลบโพสต์แล้ว',
    postDeleteConfirm: 'ลบโพสต์นี้หรือไม่',
    report: 'รายงาน',
    reportTitle: 'รายงานโพสต์',
    reportConfirm: 'รายงานโพสต์นี้ให้ผู้ดูแลระบบหรือไม่?',
    reportReason: 'เหตุผล (ไม่บังคับ)',
    reportDone: 'ส่งรายงานแล้ว ขอบคุณ',
    visPrivate: 'เฉพาะฉัน',
    followRequested: 'ส่งคำขอแล้ว',
    followAccept: 'ยอมรับ',
    followDecline: 'ปฏิเสธ',
    followAccepted: 'ยอมรับคำขอติดตามแล้ว',
    unfollow: 'เลิกติดตาม',
    unfollowConfirm: 'เลิกติดตามผู้ใช้นี้หรือไม่?',
    connectionsHint: 'ส่งคำขอติดตามได้จากโพสต์ในฟีด เมื่อได้รับการยอมรับจะเห็นโพสต์เฉพาะผู้ติดตาม',
    sharePhotos: 'เพิ่มรูปภาพ (สูงสุด 4 รูป)',
    sharePhotosHint: 'ข้อมูลตำแหน่ง (EXIF) จะถูกลบโดยอัตโนมัติ',
    snsShare: 'แชร์',
    copyLink: 'คัดลอกลิงก์',
    linkCopied: 'คัดลอกลิงก์แล้ว',
    shareOther: 'แอปอื่น ๆ',
    instagramSaved: 'บันทึกรูปการ์ดแล้ว โพสต์ผ่านแอป Instagram ได้เลย',
    manualRecords: 'บันทึกด้วยตนเอง',
    addManualRecord: 'เพิ่มบันทึกด้วยตนเอง',
    manualChip: 'ด้วยตนเอง',
    recordStart: 'เวลาเริ่ม',
    recordEnd: 'เวลาสิ้นสุด',
    recordMemo: 'บันทึกช่วยจำ',
    recordDuration: 'ระยะเวลา (นาที)',
    recordCreated: 'เพิ่มบันทึกแล้ว',
    recordDeleteConfirm: 'ลบบันทึกนี้หรือไม่?',
    noManualRecords: 'ยังไม่มีบันทึกด้วยตนเอง',
    poiRecords: 'จุดที่สนใจ',
    addPoi: 'เพิ่มจุดที่สนใจ',
    poiTitle: 'ชื่อ',
    poiMapHint: 'คลิกแผนที่เพื่อกำหนดจุด หากไม่กำหนดจะใช้ตำแหน่งจากรูปภาพ',
    noPoiRecords: 'ยังไม่มีจุดที่สนใจ',
    map: 'แผนที่',
    mapLayers: 'เลเยอร์',
    editMode: 'โหมดแก้ไข',
    selected: 'เลือกแล้ว',
    mergeSave: 'บันทึกแบบรวม',
    clipDraw: 'วาดพื้นที่ตัด',
    saveAsField: 'บันทึกพื้นที่เพาะปลูกเป็นแปลง',
    workWidthM: 'ความกว้างการทำงาน (ม.)',
    workName: 'ชื่อ',
    workSaved: 'บันทึกรายการที่สร้างแล้ว',
    derivedRecords: 'รายการที่สร้างขึ้น',
    derivedChip: 'ที่สร้างขึ้น',
    derivedDeleteConfirm: 'ลบรายการที่สร้างขึ้นนี้หรือไม่?',
    saveRangeAsWork: 'บันทึกช่วงที่เลือกเป็นรายการที่สร้างขึ้น',
    clipByField: 'ตัดตามแปลง',
    showOnMap: 'แสดงบนแผนที่',
    editRange: 'แก้ไขช่วง',
    trajectoryChip: 'GPS',
    derivedRecordsDescription:
      'บันทึกงานที่จับคู่ 1:1 กับเส้นทางแต่ละเส้น รายการที่แก้ไขและบันทึกด้วยตนเองจะแสดงที่นี่ด้วย',
    spatialEdit: 'ตัด / บันทึกเป็นแปลง',
    vraTitle: 'แผนที่ VRA',
    vraDescription: 'สร้างแผนที่โซนสำหรับการใส่ปุ๋ยแบบแปรผันจากดัชนีพืชพรรณดาวเทียม',
    vraGenerate: 'สร้างแผนที่ใหม่',
    vraIndex: 'ดัชนีพืชพรรณ',
    vraGridSize: 'กริด (ม.)',
    vraDirection: 'ทิศทาง (องศา)',
    vraCloudPct: 'เมฆสูงสุด (%)',
    vraImages: 'ภาพที่ใช้',
    vraFailed: 'สร้างไม่สำเร็จ อาจไม่มีภาพที่ไร้เมฆในช่วงเวลาที่เลือก',
    saveFailed: 'บันทึกไม่สำเร็จ',
    mapSetGenerated: 'สร้างเสร็จแล้ว',
    fieldValidFromDate: 'ใช้ได้ตั้งแต่: {date}',
    fieldDeleteLinked: 'ไม่สามารถลบ {fieldName} ได้เนื่องจากเชื่อมโยงกับข้อมูลต่อไปนี้',
    fieldDeleteLinkedTasks: 'บันทึกการทำงาน: {count} รายการ',
    fieldDeleteLinkedSets: 'ชุดแปลง: {names}',
    fieldDeleteLinkedHint: 'หากต้องการลบ โปรดลบ/ยกเลิกบันทึกการทำงานและชุดแปลงที่เชื่อมโยงก่อน',
    elevSource: 'แหล่งข้อมูล',
    elevSourceDem: 'ดาวเทียม (DEM)',
    elevSourceGnss: 'ประวัติการทำงาน (GNSS)',
    elevCenter: 'จุดกึ่งกลางของสี',
    elevCenterMean: 'ค่าเฉลี่ย',
    elevCenterMedian: 'ค่ามัธยฐาน',
    elevCenterValue: 'ความสูงกึ่งกลาง',
    elevCustom: 'กำหนดเอง',
    elevRange: 'ช่วงของสี',
    elevRangeWidth: 'ความกว้างช่วง',
    elevContour: 'เส้นชั้นความสูง',
    zoneBands: 'จำนวนโซน',
    zonePalette: 'Color scheme',
    paletteHue: 'HSI (green→yellow→red)',
    paletteYlgn: 'Yellow→Green',
    paletteGnrd: 'Green→Red',
    reclassifyTitle: 'เปลี่ยนโซน/สี (ไม่ต้องสร้างใหม่)',
    reclassifyApply: 'นำการจัดโซนใหม่ไปใช้',
    followByEmail: 'ส่งคำขอติดตามด้วยอีเมล',
    emailUserNotFound: 'ไม่พบผู้ใช้สำหรับอีเมลนี้',
    followRequestSent: 'ส่งคำขอติดตามแล้ว',
    eventSettingsTitle: 'Feed settings (auto events)',
    eventSettingsVisibility: 'Event visibility',
    eventSettingsLocation: 'Location visibility',
    eventSettingsSnsStrip: 'Strip exact location when sharing to SNS (default)',
    eventSettingsPrefs: 'Events posted to your feed',
    locHidden: 'Hidden',
    locApprox: 'Approximate (~10 km grid)',
    locExact: 'Include exact location',
    event_work_start: 'Work started',
    event_work_end: 'Work finished',
    event_field_enter: 'Entered field',
    event_field_exit: 'Left field',
    event_poi_added: 'POI added',
    event_vra_map_added: 'VRA map added',
    event_elevation_map_added: 'Height map added',
    event_refline_added: 'Guidance line added',
    event_field_added: 'Field added',
    event_field_set_added: 'Field set added',
    event_work_start_text: 'started working ({name})',
    event_work_end_text: 'finished working ({name})',
    event_field_enter_text: 'entered field \u201c{name}\u201d',
    event_field_exit_text: 'left field \u201c{name}\u201d',
    event_poi_added_text: 'added POI \u201c{name}\u201d',
    event_vra_map_added_text: 'created VRA map \u201c{name}\u201d',
    event_elevation_map_added_text: 'created height map \u201c{name}\u201d',
    event_refline_added_text: 'added guidance lines ({name})',
    event_field_added_text: 'added field \u201c{name}\u201d',
    event_field_set_added_text: 'created field set \u201c{name}\u201d',
    vraNameAuto: 'ชื่อ (เว้นว่าง = อัตโนมัติ)',
    eventPrefOff: 'Do not post',
    visEditTitle: 'Change visibility',
    visEditLocationExact: 'Show exact location (map background)',
    visEditRemoveLocation: 'Remove exact location',
    visEditPublicNote: 'Exact location is automatically excluded for public posts',
    consentRequiredToShare: 'Sharing requires consent to the sharing terms. Enable sharing from a regular post first',
    elevGnssFailed:
      'คำนวณความสูงต่ำไม่สำเร็จ ไม่พบประวัติการทำงาน (ค่าความสูง GNSS) ที่ตรงกับตัวกรอง หรือยังประมวลผลอยู่ ลองผ่อนปรนตัวกรองสถานะ GNSS หรือช่วงวันที่',
    elevDescription:
      'สร้างแผนที่ความสูงต่ำจากค่าความสูง GNSS ในประวัติการทำงาน (แนะนำ RTK) หากไม่มีประวัติ สามารถใช้ข้อมูลความสูงดาวเทียม (DEM) ได้ ซิงก์กับ NAVI ได้เช่นเดียวกับแผนที่ VRA',
    fieldValidUntil: 'ใช้ได้ถึง: {date}',
    mapSetGeneratedWithCount: 'สร้างแล้ว {created} / ล้มเหลว {failed} (แผนที่เดิมของแปลงเดียวกันจะถูกแทนที่)',
    vraGenerating: 'กำลังวิเคราะห์ภาพดาวเทียม...',
    vraObsDate: 'วันที่สังเกต',
    vraPeriodMean: 'ค่าเฉลี่ยช่วงเวลา',
    vraLimitReached: 'ถึงขีดจำกัดการสร้างแล้ว (Free: รวม 3 ครั้ง, แผนชำระเงิน: 10 ครั้งต่อวัน)',
    vraExport: 'ส่งออก ISOXML',
    vraModeGrid: 'เมช (กริด)',
    vraModePolygon: 'โพลิกอน',
    vraRate: 'อัตราการใส่ (กก./เฮกตาร์)',
    vraCellSize: 'ขนาดเซลล์ (ม.)',
    vraEditMap: 'แก้ไข',
    mapSets: 'ชุดแปลง',
    mapSetDescription: 'จัดกลุ่มแปลงด้วยตัวกรอง (ช่วงเวลาใช้งาน พืช ชื่อ) ใช้สำหรับสร้างแผนที่ VRA แบบชุด',
    mapSetCreate: 'สร้างชุดแปลง',
    fieldSetEmpty: 'ยังไม่มีชุดแปลง',
    mapSetTargetDate: 'วันที่เป้าหมาย',
    mapSetCrop: 'พืช',
    mapSetNameContains: 'ชื่อแปลง (มีคำ)',
    mapSetMemoContains: 'บันทึก (มีคำ)',
    mapSetPreviewCount: 'แปลงที่ตรงกัน',
    mapSetGenerate: 'สร้าง/อัปเดต',
    mapSetFields: 'จำนวนแปลง',
    mapSetLastGenerated: 'สร้างล่าสุด',
    fieldAttrsTitle: 'คุณสมบัติแปลง (ช่วงเวลาและพืช)',
    fieldValidFrom: 'เริ่มใช้ (ว่าง = ไม่จำกัด)',
    fieldValidTo: 'สิ้นสุด (ว่าง = ไม่จำกัด)',
    mapSetNoMatch: 'ไม่มีแปลงที่ตรงกับตัวกรอง',
    mapSetDeleteConfirm: 'ลบชุดแปลงนี้และแผนที่ VRA ที่สร้างจากชุดนี้หรือไม่?',
    trajectories: 'เส้นทางการเดินรถ',
  },
  marketInsights: {
    menu: 'ข้อมูลตลาด',
    title: 'ข้อมูลตลาด (AgriBus-DWH)',
    description:
      'ติดตามความคืบหน้าของงานในไร่และการสังเกตตลาดของแหล่งปลูกถั่วเหลืองและข้าวสาลีหลักของโลกได้ทุกวัน เป็นสิทธิประโยชน์ของสมาชิก: ข้อมูลการทำงานของคุณ (สถิติแบบไม่ระบุตัวตน) จะถูกส่งกลับมาเป็นข้อมูลช่วยตัดสินใจ เช่น จังหวะการขายผลผลิต',
    soybeanDescription: 'สภาพการเพาะปลูกและสัญญาณตลาดของแหล่งปลูกถั่วเหลืองในบราซิลและสหรัฐฯ',
    wheatDescription: 'สภาพการเพาะปลูกและสัญญาณตลาดของแหล่งปลูกข้าวสาลี',
    open: 'เปิด',
    upsell:
      'ข้อมูลตลาดเป็นสิทธิประโยชน์สำหรับสมาชิกแผนแบบชำระเงิน เมื่อสมัครแผนแบบชำระเงินจะดูได้โดยไม่มีค่าใช้จ่ายเพิ่มเติม',
    memberNote: 'เมื่อดูในฐานะสมาชิก จะมีป้ายแสดงที่มุมซ้ายบนของหน้าจอมอนิเตอร์ ข้อมูลนี้ไม่ใช่คำแนะนำการลงทุน',
  },
}
